export default {
    title: 'Phòng chờ',

    menu: {
        starDraw: 'Gacha sao',
        seedLetter: 'Chữ cơ bản',
        recentResult: {
            label: 'Kết quả buổi học gần đây',
            short: 'Kết quả<br/>buổi học gần đây',
        },
    },

    studentInfo: {
        gradeFormat: 'Lớp {grade}',
        logoutConfirm: {
            title: 'Đăng xuất',
            message: 'Bạn có muốn đăng xuất không?',
        },
    },

    navigation: {
        toAvatars: 'Đi đến Gacha sao',
        toSeedLetter: 'Đi đến Chữ cơ bản',
        toRecentResult: 'Đi đến kết quả buổi học gần đây',
    },

    languageSetting: {
        menuLabel: 'Ngôn ngữ',
        title: 'Cài đặt ngôn ngữ',
        description: 'Bạn có thể chọn ngôn ngữ hỗ trợ trên màn hình học tập.',
    },
};
